import pairingErrors from '../../consts/device/pairingErrors';

export default class RequestDeviceError extends Error {
    constructor(e) {
        super(e);
        this.code = pairingErrors.ERROR_CONNECTION_NOT_FOUND.type;
    }
}
